import React, { useContext } from 'react'
import axios from 'axios';
import { LoginContext } from '../AuthContext/LoginContext';
import { useNavigate } from 'react-router-dom';
const Login = () => {
    const nav=useNavigate();
    const {handleLogin}=useContext(LoginContext);
    const handleSubmit=(e)=>{
        e.preventDefault();
        const data={
            email:e.target[0].value,
            password:e.target[1].value
        }
        const url=`${process.env.REACT_APP_BASE}/auth/login`;
        axios.post(url,data).then((res)=>{
            return(res.data);
        }).then(res=>{
            console.log(res);
            handleLogin(res);
            nav("/profile");
        }).catch((err)=>{
            alert("Wrong Email / Password")
        })
    }
  return (  
    <section class="bg-gray-50 dark:bg-gray-900">
  <div style={{
  backgroundImage: `url(${require("./Login.gif")})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
}} class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <a href="#" class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
          CUSTOSHOE ADMIN
      </a>
      <div class="w-full bg-gray-900 rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0 " style={{ backgroundColor: 'rgba(256, 256, 256, 0.9)'}}>
          <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 class="text-xl font-bold leading-tight tracking-tight text-black md:text-2xl ">
                  Admin Login
              </h1>
              <form onSubmit={handleSubmit}class="space-y-4 md:space-y-6" action="#">
                  <div>
                      <label for="email" class="block mb-2 text-sm font-medium text-black font-semibold">Your email</label>
                      <input type="email" name="email" id="email" style={{ backgroundColor: 'rgba(250, 250, 250, 0.5)'}} class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="name@company.com" required=""/>
                  </div>
                  <div>
                      <label for="password" class="block mb-2 text-sm font-medium text-black font-semibold">Password</label>
                      <input type="password" name="password" id="password"  style={{ backgroundColor: 'rgba(250, 250, 250, 0.5)'}} placeholder="••••••••" class="bg-gray-50 text-black border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
                  </div>
                  <div class="flex items-center justify-between">
                      <a href="#" class="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500">Forgot password?</a>
                  </div>
                  <button type="submit" class="w-full text-white bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Sign in</button>
              </form>
          </div>
      </div>
  </div>
</section>
  )
}

export default Login